export enum Platform {
  AD_ROLL = "AdRoll",
  AMAZON_ADS = "AmazonAds",
  AMAZON_SELLER = "AmazonSeller",
  ATTENTIVE = "Attentive",
  AVANT_LINK = "AvantLink",
  BLISS_POINT_MEDIA = "BlissPointMedia",
  CNN5_THINGS = "CNN5Things",
  CRITEO = "Criteo",
  GOOGLE = "Google",
  GRIN = "Grin",
  IMPACT_RADIUS = "ImpactRadius",
  KLAVIYO = "Klaviyo",
  LIVE_INTENT = "LiveIntent",
  MICROSOFT = "Microsoft",
  META = "Meta",
  MNTN = "MNTN",
  OUTBRAIN = "Outbrain",
  POSTSCRIPT = "Postscript",
  PARTNERIZE = "Partnerize",
  PINTEREST = "Pinterest",
  RAKUTEN = "Rakuten",
  RETENTION_SCIENCE = "Retention Science",
  REVCONTENT = "Revcontent",
  SHARE_A_SALE = "ShareASale",
  SNAPCHAT = "Snapchat",
  STACK_ADAPT = "StackAdapt",
  TABOOLA = "Taboola",
  TATARI = "Tatari",
  TIKTOK = "TikTok",
  TRADE_DESK = "Trade Desk",
  TWITTER = "Twitter",
  APPLOVIN = "AppLovin",
  YAHOO_DSP = "Yahoo DSP",
  UNKNOWN = "unknown",
  OTHER = "Other",
}

export enum UtmChangeImpact {
  HIGH = "high",
  SOMEWHAT = "somewhat",
  NOT_IMPACTED = "not-impacted",
}

export enum UtmParam {
  SOURCE = "utm_source",
  MEDIUM = "utm_medium",
  CAMPAIGN = "utm_campaign",
  TERM = "utm_term",
  CONTENT = "utm_content",
}
